module.exports = __webpack_public_path__ + "static/hero2-604e3809f52b3769f9b2d4ff79768335.jpg";